import {copy} from '../../../../../../../util/fieldscopy'
import {FormSectionType} from '../../../../../../blocks/FormBlock'
import box from '../../fields/box'
import city from '../../fields/city'
import houseNumber from '../../fields/houseNumber'
import organisation from '../../fields/organisation'
import organisationType from '../../fields/organisationType'
import street from '../../fields/street'
import zip from '../../fields/zip'

const clientData: FormSectionType = {
	id: 6,
	parent_id: 2,
	channel: 'section',
	label: copy?.client_details || 'Klantengegevens',
	fields: [
		organisation,
		organisationType,
		street,
		houseNumber,
		box,
		zip,
		city
	].map((field) => {
		return {...field, parent_id: 6}
	})
}

export default clientData
